import moment from "moment";

export default (elt) => {
  console.log(elt, "data");
  return({
  title: elt.message  
    ? elt.message.length > 50
      ? `${elt.message.replace(/\-/, " ").substring(0, 50)}...`
      : elt.message
    : elt.message,
  status: elt.firstName,
  author: elt.lastName,
  postDate: elt.email,
  updated: moment(elt.createdAt).format("ll"),
  id: elt.id || elt._id,
})};

export const folderDate = new Date()
  .toISOString()
  .replace("-", "")
  .substring(0, 6);
